module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-add-foobar"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "foobar-title"
    }
  }, [_vm._v("Title")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFoobar.title),
      expression: "newFoobar.title"
    }],
    staticClass: "full",
    attrs: {
      "id": "foobar-title",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFoobar.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newFoobar, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', {
    attrs: {
      "for": "foobar-description"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.field.description')))]), _c('br'), _vm._v(" "), _c('quill-editor', {
    attrs: {
      "id": "foobar-description",
      "options": _vm.quillOptionsDescription
    },
    on: {
      "change": _vm.changeDescription
    },
    model: {
      value: (_vm.newFoobar.description),
      callback: function($$v) {
        _vm.$set(_vm.newFoobar, "description", $$v)
      },
      expression: "newFoobar.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.saveFoobar
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus-square"
    }
  }), _vm._v(" \n              " + _vm._s(_vm.$t('message.button.add_foobar')) + "\n            ")], 1)], 1)])]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  })], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585a2687"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foobar/FoobarAdd.vue
// module id = 1834
// module chunks = 1